/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_ApprovedInputs */

const en_wb_support_approved = /** @type {(inputs: Wb_Support_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example approved. The next step would be to send the reply and record the conversation.`)
};

const lv_wb_support_approved = /** @type {(inputs: Wb_Support_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs apstiprināts. Nākamais solis būtu nosūtīt atbildi un saglabāt sarunu.`)
};

/**
* | output |
* | --- |
* | "Example approved. The next step would be to send the reply and record the conversation." |
*
* @param {Wb_Support_ApprovedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_approved = /** @type {((inputs?: Wb_Support_ApprovedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_ApprovedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_approved(inputs)
	return en_wb_support_approved(inputs)
});